import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { shiftHasDropPenalty } from '../../../../../utils';
import { formatDuration } from '@amzn/atoz-shiftapp-utilities';
export var RadioCardMessage = function (_a) {
    var dropOpportunity = _a.dropOpportunity, scheduleShift = _a.scheduleShift;
    var t = useTranslation().t;
    var hasDropPenalty = shiftHasDropPenalty(scheduleShift, dropOpportunity);
    var renderMessage = function () {
        if (hasDropPenalty) {
            return (React.createElement(Text, { fontSize: 'T100', fontWeight: 'light', "data-testid": "merged-shift-penalty-message" }, t('shift_management_features_MultipleDropShiftModal_radio_message_drop_penalty')));
        }
        if (dropOpportunity && dropOpportunity.penaltyStartTime) {
            return (React.createElement(Text, { fontSize: 'T100', fontWeight: 'light', "data-testid": "merged-shift-countdown-message" },
                t('shift_management_features_MultipleDropShiftModal_radio_message_drop_without_penalty'),
                ' ',
                formatDuration(DateTime.fromISO(dropOpportunity.penaltyStartTime).diff(DateTime.utc(), ['hours', 'minutes', 'seconds']))));
        }
        return null;
    };
    return React.createElement(View, null, renderMessage());
};
